import {FILTER_OPTIONS} from './../../services/flightsFactory';

export default function FlightsClearFiltersBaseController(
    $scope,
    $rootScope,
    flightsFactory,
    baseEvents
) {
    'ngInject';

            /**
             * Indicate carousel filtering
             */
            $scope.carouselFilterApplied = false;

            let clearFiltersClicked = false;

            $scope.$on(baseEvents.APPLY_FILTERS, function() {
                if (!clearFiltersClicked) {
                    $scope.carouselFilterApplied = true;
                }
                clearFiltersClicked = false;
            });

            /**
             * Reset filters to show all airlines
             */
            $scope.showAllAirlines = function() {
                flightsFactory.params.Filters = {QuantityOfStops: FILTER_OPTIONS.STOPS.ALL};
                flightsFactory.params.SegmentFilterData = [];

                $scope.carouselFilterApplied = false;
                $rootScope.$broadcast(baseEvents.CLEAR_SEGMENTS);

                $scope.clearFilters();
            };

            /**
             * Remove all filtering rules
             */
            $scope.clearFilters = function() {
                clearFiltersClicked = true;
                $rootScope.$broadcast(baseEvents.CLEAR_FILTERS);
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/flightsClearFiltersBaseCtrl.js